import { createContext, useContext } from "react";

export const CycleDataContext = createContext(null);

export function useCycleDataContext() {
  const ctx = useContext(CycleDataContext);
  if (!ctx) throw new Error("useCycleDataContext must be used inside CycleDataContext.Provider");
  return ctx;
}
